<script>
export default {
  name: 'DeferredRenderFrame',
  props: {
    maxFrame: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      frameNum: 0,
      maxFrameAchieved: this.maxFrame <= this.frameNum,
    }
  },
  mounted() {
    if (this.maxFrameAchieved) {
      return
    }

    this.runFrameCounter()
  },
  methods: {
    runFrameCounter() {
      const step = () => {
        requestAnimationFrame(() => {
          if (this.frameNum >= this.maxFrame) {
            this.maxFrameAchieved = true

            return
          }

          this.frameNum++
          step()
        })
      }

      step()
    },
  },
  render() {
    return this.$scopedSlots.default({
      currentFrame: this.frameNum,
      maxFrameAchieved: this.maxFrameAchieved,
    })
  },
}
</script>
